document.addEventListener('DOMContentLoaded', function () {

  document.querySelectorAll('[data-miuvi-product-form]').forEach(function (form) {
    var variantsJson = form.querySelector('[data-miuvi-variants-json]');
    var variants = [];
    if (variantsJson) {
      try { variants = JSON.parse(variantsJson.textContent); } catch (e) { variants = []; }
    }

    var idInput = form.querySelector('[data-miuvi-variant-id]');
    var priceEl = document.querySelector('[data-miuvi-price]');
    var availabilityEl = document.querySelector('[data-miuvi-availability]');
    var submitBtn = form.querySelector('[data-miuvi-submit]');
    var optionSelects = form.querySelectorAll('[data-miuvi-option]');

    function currentSelection() {
      var selected = [];
      optionSelects.forEach(function (select) { selected.push(select.value); });
      return selected;
    }

    function findVariant(selection) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var matches = true;
        for (var j = 0; j < selection.length; j++) {
          if (v.options[j] !== selection[j]) { matches = false; break; }
        }
        if (matches) return v;
      }
      return null;
    }

    function formatMoney(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    function updateForVariant(variant) {
      if (!variant) {
        if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = submitBtn.getAttribute('data-unavailable-text') || 'Unavailable'; }
        return;
      }
      if (idInput) { idInput.value = variant.id; }
      if (priceEl && typeof variant.price !== 'undefined') { priceEl.textContent = formatMoney(variant.price); }
      if (submitBtn) {
        if (variant.available) {
          submitBtn.disabled = false;
          submitBtn.textContent = submitBtn.getAttribute('data-add-text') || 'Add to cart';
        } else {
          submitBtn.disabled = true;
          submitBtn.textContent = submitBtn.getAttribute('data-soldout-text') || 'Sold out';
        }
      }
      if (availabilityEl) {
        availabilityEl.textContent = variant.available ? '' : 'Currently sold out';
      }
    }

    if (optionSelects.length && variants.length) {
      optionSelects.forEach(function (select) {
        select.addEventListener('change', function () {
          updateForVariant(findVariant(currentSelection()));
        });
      });
      updateForVariant(findVariant(currentSelection()));
    } else if (variants.length === 1) {
      updateForVariant(variants[0]);
    }

    var qtyMinus = form.querySelector('[data-miuvi-qty-minus]');
    var qtyPlus = form.querySelector('[data-miuvi-qty-plus]');
    var qtyInput = form.querySelector('[data-miuvi-qty-input]');
    if (qtyMinus && qtyPlus && qtyInput) {
      qtyMinus.addEventListener('click', function () {
        var val = parseInt(qtyInput.value, 10) || 1;
        if (val > 1) { qtyInput.value = val - 1; }
      });
      qtyPlus.addEventListener('click', function () {
        var val = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = val + 1;
      });
    }
  });

  document.querySelectorAll('[data-miuvi-gallery]').forEach(function (gallery) {
    var mainImg = gallery.querySelector('[data-miuvi-gallery-main] img');
    var thumbs = gallery.querySelectorAll('[data-miuvi-thumb]');
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var full = thumb.getAttribute('data-full');
        var alt = thumb.getAttribute('data-alt');
        if (mainImg && full) { mainImg.src = full; mainImg.alt = alt || mainImg.alt; }
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  });

  document.querySelectorAll('[data-miuvi-faq]').forEach(function (item) {
    var summary = item.querySelector('summary');
  });

  document.querySelectorAll('[data-miuvi-scroll-to]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      var targetId = btn.getAttribute('data-miuvi-scroll-to');
      var target = document.getElementById(targetId);
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  var mainAtc = document.querySelector('[data-miuvi-main-atc]');
  var stickyBar = document.querySelector('[data-miuvi-sticky-bar]');
  if (mainAtc && stickyBar && 'IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        stickyBar.classList.toggle('is-visible', !entry.isIntersecting);
      });
    }, { threshold: 0 });
    observer.observe(mainAtc);
  }

  document.querySelectorAll('[data-miuvi-trigger-main-atc]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var currentMainAtc = document.querySelector('[data-miuvi-main-atc]');
      var mainForm = document.querySelector('[data-miuvi-product-form]');
      if (!currentMainAtc || currentMainAtc.disabled) { return; }
      if (mainForm && typeof mainForm.requestSubmit === 'function') { mainForm.requestSubmit(currentMainAtc); }
      else if (mainForm) { mainForm.submit(); }
    });
  });
});
